__webpack_require__.p = "/partner-portal/home/";